import React from 'react'
import PropTypes from 'prop-types'

const IconCredits = ({ className }) => {
  return (
    <svg
      id='credits'
      width='94'
      height='94'
      viewBox='0 0 94 94'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g fill='none' fillRule='evenodd'>
        <circle fill='#FFF' cx='47' cy='47' r='47' />
        <g strokeWidth='1.5' stroke='#5A5654'>
          <path
            fill='#D8D8D8'
            d='M60.38 46.353l5.726-5.602 3.452 4.774-4.147 3'
          />
          <path
            fill='#D8D8D8'
            d='M35.19 65.99L21.03 52.457l30.28-30.283L67.995 38.86l-8.104 8.154'
          />
          <path
            d='M69.355 52.66v13.808c0 3.05-7.648 5.527-17.084 5.527-9.433 0-17.08-2.476-17.08-5.53V52.662'
            fill='#FFF'
          />
          <path d='M35.19 59.72c0 3.052 7.647 5.528 17.08 5.528 9.437 0 17.084-2.476 17.084-5.53' />
          <path
            d='M69.355 52.292c0 3.258-7.648 5.896-17.084 5.896-9.433 0-17.08-2.64-17.08-5.896 0-3.257 7.647-5.896 17.08-5.896 9.437 0 17.085 2.638 17.085 5.896z'
            fill='#FFF'
          />
        </g>
      </g>
    </svg>
  )
}

IconCredits.propTypes = {
  className: PropTypes.string
}

export default IconCredits
